import { ajaxPostJson, setParams } from './ajax';
//分页获取记忆库列表
export const getTermList = (params) => {
  params.filter = setParams(params.filter)
  return ajaxPostJson(`/term/queryPage`, params, 'BaseApi');
};
// 轮询状态 获取列表表格的 sendCount
export const termQuerySentCount = (params) => {
  return ajaxPostJson(`/term/querySentCount`, params, 'BaseApi');
};
// 添加列表
export const addTermList = (params) => {
  params.dataType = 'trans_domain'
  return ajaxPostJson(`/term/addTransTermLib`, params, 'BaseApi');
};
//获取语言方向
// export const languageDirections = (params) => {
//   return ajaxPostJson(`/term/queryLangDescList`, params, 'BaseApi');
// };
export const languageDirections = (params) => {
  return ajaxPostJson(`/term/queryLangDescAndCodeList`, params, 'BaseApi');
};
//获取领域
export const getTerritory = (params) => {
  return ajaxPostJson(`/term/queryDomainList`, params, 'BaseApi');
};
//获取创建术语库的语言
export const getLang = (params) => {
  return ajaxPostJson(`/common/queryLangList`, params, 'BaseApi');
};
//获取创建术语库的领域
export const getOptionList = (params) => {
  return ajaxPostJson(`/common/queryOptionList`, params, 'BaseApi');
};

//编辑术语库
export const uploadTerm = (params) => {
  return ajaxPostJson(`/term/updateTransTermLib`, params, 'BaseApi');
};
//删除术语库
export const delTerm = (params) => {
  return ajaxPostJson(`/term/deleteTransTermLib`, params, 'BaseApi');
};
//批量删除术语库明细
export const batchDeleteByIdList = (params) => {
  return ajaxPostJson(`/termSent/batchDeleteByIdList`, params, 'BaseApi');
};
// 新增术语库
export const addTerm = (params) => {
  params.dataType = 'trans_domain'
  return ajaxPostJson(`/term/addTransTermLib`, params, 'BaseApi');
};
// 导出术语库
export const exportTerm = (params) => {
  return ajaxPostJson(`/term/exportTermLib`, params, 'BaseApi');
};
//合并术语库
export const mergeTerm = (params) => {
  return ajaxPostJson(`/term/mergeTransTermLib`, params, 'BaseApi');
};
// 分页查询术语库明细
export const queryPageTermSent = (params) => {
  return ajaxPostJson(`/termSent/queryPage`, params, 'BaseApi');
};
// 添加术语库明细
export const addTermSent = (params) => {
  return ajaxPostJson(`/termSent/addSent`, params, 'BaseApi');
};
// 批量删除术语库明细
export const batchDeleteByTermSentIdList = (params) => {
  return ajaxPostJson(`/termSent/batchDeleteByIdList`, params, 'BaseApi');
};
//修改编辑术语库明细
// privateUpdate
export const updateTermBank = (params) => {
  return ajaxPostJson(`/termSent/privateUpdate`, params, 'BaseApi');
};
//私有版合并术语库
export const mergeTerms = (params) => {
  return ajaxPostJson(`/term/privateMergeTransTermLib`, params, 'BaseApi');
};

//术语库一键去重
export const termRemoveDeduplication = (params) => {
  return ajaxPostJson(`/term/termRemoveDeduplication`, params, 'BaseApi');
};

//术语去重中止
export const termBreakDistinct = (params) => {
  return ajaxPostJson(`/term/termBreakDistinct`, params, 'BaseApi');
};
//获取原文相同 译文不同的数据
export const termDeduplication = (params) => {
  return ajaxPostJson(`/term/termDeduplication`, params, 'BaseApi');
};
//术语去重
export const termDeleteByIdList = (params) => {
  return ajaxPostJson(`/termSent/batchDeleteByIdList`, params, 'BaseApi');
};
//术语库编辑
export const updateTermBanks = (params) => {
  return ajaxPostJson(`/termSent/update`, params, 'BaseApi');
};

/* feature1.4.3  cat1.6*/
// 术语库整体入库
export const termPutInStorage = (params) => {
  return ajaxPostJson(`/termSent/termPutInStorage`, params, 'BaseApi');
};





































